export default "__VITE_ASSET__Dot6DGuF__"